module.exports = __webpack_public_path__ + "static/media/pc.245c0313.png";